import { trans } from '@lingoda/i18n';
import type { ButtonProps, TypographyProps } from '@lingoda/ui';
import { Box, Button, Stack, Typography } from '@lingoda/ui';
import { actionClick, useUiEvent } from '@lingoda/analytics';
import type { MouseEvent } from 'react';

export interface SectionWrapperProps {
    title: string | React.ReactNode;
    children: React.ReactNode;
    titleProps?: TypographyProps;
    viewAllProps?: ButtonProps;
    eventName?: string;
}

export const SectionWrapper = ({
    title,
    titleProps,
    viewAllProps,
    children,
    eventName,
}: SectionWrapperProps) => {
    const addEvent = useUiEvent();

    const onAllClick = (event: MouseEvent<HTMLButtonElement>) => {
        if (eventName) {
            void addEvent(actionClick(eventName));
        }
        if (viewAllProps?.onClick) {
            viewAllProps.onClick(event);
        }
    };

    return (
        <Box display="flex" flexDirection="column" width="100%" data-testid={`${title}-section`}>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={1}
                mb={1.5}
            >
                <Typography variant="h2" {...titleProps}>
                    {title}
                </Typography>
                <Button
                    variant="text"
                    color="primary"
                    size="small"
                    {...viewAllProps}
                    onClick={onAllClick}
                >
                    {trans('btn-view-all', {}, 'public-common')}
                </Button>
            </Stack>
            {children}
        </Box>
    );
};
